import { render } from "./privacy-policy.vue?vue&type=template&id=3158f141&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"

import "./privacy-policy.vue?vue&type=style&index=0&id=3158f141&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3158f141"]])

export default __exports__